<template>
    <p-search-screen
        title="Sale To Wholesale"
        api-destination="wholesale"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        add-new-button
        edit-key="wholesaleId"
    >
        <template v-slot:belowSearch>
            <b-row>
                <b-col>
                    <p-checkbox
                        label="Proposed"
                        v-model="filters.proposed"
                    />
                    <p-checkbox label="Open" v-model="filters.open" />
                    <p-checkbox
                        label="Closed"
                        v-model="filters.closed"
                    />
                </b-col>
                <b-col>
                    <p-datepicker
                        label="Wholesale Date"
                        v-model="filters.createStartDate"
                        @end-of-selected-day="e => {filters.createEndDate = e}"
                    />
                </b-col>
            </b-row>
        </template>
    </p-search-screen>
</template>

<script>
import {
    dateFormatter,
    currencyFormatter
} from '@/components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'WholesaleFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'createDate',
                sortDesc: true,
                searchBy: 'All',
                proposed: true,
                open: true,
                closed: false,
                createStartDate: null,
                createEndDate:null,
            },
            filterBy: [
                'All',
                'Wholesale #',
                'SKU',
                'ISBN',
                'Barcode',
                'Supplier'
            ],
            fields: [
                {
                    key: 'wholesaleNumber',
                    sortable: true
                },
                {
                    key: 'supplier',
                    sortable: true
                },
                {
                    key: 'createDate',
                    label: 'Wholesale Date',
                    sortable: true,
                    formatter: dateFormatter
                },
                {
                    key: 'total',
                    sortable: true,
                    formatter: currencyFormatter
                },
                {
                    key: 'status',
                    sortable: true
                }
            ]
        };
    }
};
</script>
